/**
 * total activity percentage (if it is 100% capacity) multiplied by the current capacity 
 * ( eg:37.2*100/100)- for the capacities to be calculated.
actual activity percentage divided by per activity count - to calculate hours 
( eg: 50 (box retrieval on sunday) divivded by 31.6)
 */

import _ from "lodash";
import { useTranslation } from "react-i18next";



export const deepArrayEqual = (x, y) => _.isEmpty(_.xorWith(x, y, _.isEqual));

const normalize = (value) => {
  return parseInt(value ? value : "0");
};

const getHours = (capacity, activityCount) => {
  const count = normalize(activityCount);
  let toReturn = 0;
  if (count == 0 || capacity == 0) toReturn = 0;
  if(parseFloat(capacity)) toReturn = count / capacity;
  return fixDecimal(toReturn);
};
const getStaff = (capacity, activityCount, productHours=7.5) => {
  const count = normalize(activityCount);
  const hours = getHours(capacity, activityCount);
  let toReturn = 0;
  if (count == 0 || hours == 0 || capacity == 0) toReturn = 0;
  if(parseFloat(capacity)) toReturn = hours / productHours;
  return fixDecimal(toReturn);
};

export const fixDecimal = (n, decimal = 1) => {
  return n.toFixed(decimal);
};

export const formulas = { getHours, getStaff };

export const getRandom = (min, max) => {
  return Math.floor(Math.random() * (max - min) + min);
};

export const getTotals = (activities) => {
  // let data = e.data;
  const normalize = (value) => {
    return parseInt(value ? value : "0");
  };
  const normalizeFloat = (value) => {
    return parseFloat(value ? value : "0");
  };

  const totalFormat = { totalActivityCount: 0, totalHours: 0, totalStaff: 0 };
  const totals = {};
  const actWeekTotals = {};
  let totalValue = 0;
  let totalHours = 0.0;
  let totalStaff = 0.0;
  for (let i = 0; i < 7; ++i) {
    const index = i + 1;
    totals[`day${index}`] = { ...totalFormat };
  }
  // console.log(totals);
  const activityIds = Object.keys(activities);
  if (activityIds != null && activityIds != undefined)
    for (let id of activityIds) {
      const activity = activities[id];
      try {
        for (let i = 0; i < 7; ++i) {
          const day = `day${i + 1}`;
          // Week Total Activity Counts
          const actCount = normalize(activity[day].activityCount);
          totals[day].totalActivityCount += actCount;
          actWeekTotals[id] = actWeekTotals[id]? actWeekTotals[id] : {};
          actWeekTotals[id].totalActivityCount = actWeekTotals?.[id]?.totalActivityCount?
           actWeekTotals[id].totalActivityCount + actCount :  actCount;
          // Week Total Hours Count
          totals[day].totalHours += normalizeFloat(activity[day].hours);
          actWeekTotals[id].totalHours = actWeekTotals?.[id]?.totalHours?
           actWeekTotals[id].totalHours + normalizeFloat(activity[day].hours) :
             normalizeFloat(activity[day].hours);
          // Week Total Staff Count
          totals[day].totalStaff += normalizeFloat(activity[day].staff);
          actWeekTotals[id].totalStaff = actWeekTotals?.[id]?.totalStaff?
           actWeekTotals[id].totalStaff + normalizeFloat(activity[day].staff) :
           normalizeFloat(activity[day].staff);
          totalValue += actCount;
          totalHours += normalizeFloat(activity[day].hours);
          totalStaff += normalizeFloat(activity[day].staff)
        }
         actWeekTotals[id].totalHours = fixDecimal(actWeekTotals[id].totalHours);
         actWeekTotals[id].totalStaff = fixDecimal(actWeekTotals[id].totalStaff);

      } catch (e) {
        console.error("Error for", activity, e);
      }
    }

  for (let i = 0; i < 7; ++i) {
    const index = i + 1;
    totals[`day${index}`].totalHours = fixDecimal(
      totals[`day${index}`].totalHours
    );
    totals[`day${index}`].totalStaff = fixDecimal(
      totals[`day${index}`].totalStaff
    );
  }

  totals['weekTotal'] = {
    totalActivityCount : totalValue,
    totalStaff : fixDecimal(totalStaff),
    totalHours : fixDecimal(totalHours)
  }

  return { totals, totalValue, actWeekTotals };
};

// Deep Equals
export const deepEqual = (object1, object2) => {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (const key of keys1) {
    const val1 = object1[key];
    const val2 = object2[key];
    const areObjects = isObject(val1) && isObject(val2);
    if (
      (areObjects && !deepEqual(val1, val2)) ||
      (!areObjects && val1 !== val2)
    ) {
      return false;
    }
  }

  return true;
};

const isObject = (object) => {
  return object != null && typeof object === "object";
};

export const createActivityData = (acts) => {
  let obj = {};
  for (let a of acts) {
    if (!obj[a.id]) {
      let rec = {};
      for (let i = 0; i < 7; ++i) {
        rec[`day${i + 1}`] = {
          activityCount: "",
          hours: "",
          staff: "",
        };
      }
      rec['weekTotal'] = {
        activityCount: "0",
          hours: "0.0",
          staff: "0.0",
      }
      obj[a.id] = rec;
    }
  }
  return obj;
};

export const createDaysData = () => {
  return {
    day1: { enabled: false },
    day2: { enabled: true },
    day3: { enabled: true },
    day4: { enabled: true },
    day5: { enabled: true },
    day6: { enabled: true },
    day7: { enabled: false },
  };
};

export const addDemoAverages = (acts) => {
  return acts.map((act) => ({
    ...act,
    averages: { weekly: 340.35, monthly: 321.56, quarterly: 200.333333 },
  }));
};

export const getAverage = (activity, averageBy, allActivities) => {
  // if (
  //   !activity.averages ||
  //   !averageBy ||
  //   !averageBy.id ||
  //   !activity.averages[averageBy.id]
  // )
  //   return "";
  // return fixDecimal(activity.averages[averageBy.id]);
let averageValue = 0;
let  activityList = allActivities?.activities;
let  activityAverages = allActivities?.averages;
if(activity.id === activity.parentId){
 let curActivityList = activityList ? activityList.filter(act => 
  (!act.isParent || act.id === act.parentId) && act.parentId && act.parentId == activity.id):[];
 if(activityAverages && Object.keys(activityAverages).length>0){
  curActivityList.forEach(act =>{
    if( averageBy && averageBy.id && activityAverages[act.idNum]
        && activityAverages[act.idNum].averages
        && activityAverages[act.idNum].averages[averageBy.id])
      {
          averageValue+=(activityAverages[act.idNum].averages[averageBy.id]);
      }
   })
 }
}else{
  if(activityAverages && Object.keys(activityAverages).length>0
      && activityAverages[activity.idNum]
      && activityAverages[activity.idNum].averages
      && activityAverages[activity.idNum].averages[averageBy.id])
      {
        averageValue = activityAverages[activity.idNum].averages[averageBy.id];
      }
}
return averageValue && !isNaN(averageValue)?fixDecimal(averageValue):0;
};

export const removeDataForDisabledDays = (input) => {
  const normalize = (value) => {
    return parseInt(value ? value : "0");
  };
  const normalizeFloat = (value) => {
    return parseFloat(value ? value : "0");
  };
  const data = _.cloneDeep(input);

  const enabled = getEnabledDays(data.daysData);

  const weekTotalDays = {
    totalActivityCount:0,
    totalHours:0,
    totalStaff:0
  }

  // Making count, hours, staff of disabled columns activities as ""
  const acts = Object.keys(data.activityData);
  for (const act of acts) {
    let weekTotal = {
      activityCount:0,
      hours:0,
      staff:0
    }
    const days = Object.keys(data.activityData[act]);
    for (const day of days) {
      if (!enabled.includes(day)) {
        data.activityData[act][day].activityCount = "";
        data.activityData[act][day].hours = "";
        data.activityData[act][day].staff = "";
      }else{
        weekTotal["activityCount"] += normalize(data.activityData[act][day].activityCount);
        weekTotal["hours"] += normalizeFloat(data.activityData[act][day].hours);
        weekTotal["staff"] += normalizeFloat(data.activityData[act][day].staff);
        weekTotalDays["totalActivityCount"] += normalize(data.activityData[act][day].activityCount);
        weekTotalDays["totalHours"] += normalizeFloat(data.activityData[act][day].hours);
        weekTotalDays["totalStaff"] += normalizeFloat(data.activityData[act][day].staff);
      }
    }
    data.activityData[act]['weekTotal'].activityCount = weekTotal["activityCount"];
    data.activityData[act]['weekTotal'].hours = weekTotal["hours"].toFixed(1);
    data.activityData[act]['weekTotal'].staff = weekTotal["staff"].toFixed(1);
  }
  // Remove all the manual activities with no activityName
  if(data.customActData && data.customActData.length>0){
    data.customActData = data.customActData.filter(manAct => !!(manAct.activityName && manAct.activityTarget));
  }else{
    data.customActData = [];
  }

   // Making count, hours, staff of disabled columns of manual activities as ""
   const manualActs = data.customActData ? data.customActData : [] ;
   manualActs.forEach(manAct => {
    let weekTotal = {
      activityCount:0,
      hours:0,
      staff:0
    }
    const days = Object.keys(manAct.dayPlan);
    manAct.activityName = manAct.activityName? manAct.activityName.toUpperCase()  : "";
    for (const day of days) {
      if (!enabled.includes(day)) {
        manAct.dayPlan[day].activityCount = "";
        manAct.dayPlan[day].hours = "";
        manAct.dayPlan[day].staff = "";
      }else{
        weekTotal["activityCount"] += normalize(manAct.dayPlan[day].activityCount);
        weekTotal["hours"] += normalizeFloat(manAct.dayPlan[day].hours);
        weekTotal["staff"] += normalizeFloat(manAct.dayPlan[day].staff);
        weekTotalDays["totalActivityCount"] += normalize(manAct.dayPlan[day].activityCount);
        weekTotalDays["totalHours"] += normalizeFloat(manAct.dayPlan[day].hours);
        weekTotalDays["totalStaff"] += normalizeFloat(manAct.dayPlan[day].staff);
      }
    }
    manAct.dayPlan['weekTotal'].activityCount = weekTotal["activityCount"];
    manAct.dayPlan['weekTotal'].hours = weekTotal["hours"].toFixed(1);
    manAct.dayPlan['weekTotal'].staff = weekTotal["staff"].toFixed(1);
   })

  // Making totals of disabled columns as zero
  for (let i = 0; i < 7; ++i) {
    const day = `day${i + 1}`;
    if (!enabled.includes(day)) {
      data.weekTotal[day].totalActivityCount = "0";
      data.weekTotal[day].totalHours = "0";
      data.weekTotal[day].totalStaff = "0";
    }
  }
  data.weekTotal['weekTotal'].totalActivityCount = weekTotalDays.totalActivityCount;
  data.weekTotal['weekTotal'].totalHours = weekTotalDays.totalHours.toFixed(1);
  data.weekTotal['weekTotal'].totalStaff = weekTotalDays.totalStaff.toFixed(1);
  return data;
};

export const isDayToggleOff = (daysData, day) => {
  if (!daysData || !day) return false;
  return !daysData[day].enabled;
};

export const getEnabledDays = (daysData) => {
  if (!daysData) return [];
  const enabled = Object.entries(daysData)
    .filter((entry) => entry[1].enabled)
    .map((e) => e[0]);
  return enabled;
};

export const filterActs = (data) => {
  return data
    .filter((item) => item.isEnabled && item.isParent)
    .sort((a, b) => getDisplayActicityName(a).localeCompare(getDisplayActicityName(b)));
};

export const groupByParent = (activities) => {
  const parents = {};
  for (const act of activities) {
    if (parents[act.parentId]) {
      parents[act.parentId].push(act.id);
    } else {
      parents[act.parentId] = [];
      parents[act.parentId].push(act.id);
    }
  }
  return parents;
};

export const findParentDetails = (parentIds, activities) => {
  const details = [];
  for (const id of parentIds) {
    const p = activities.find((a) => a.id == id);
    if (p != undefined) details.push(p);
  }
  return details;
};

export const getDisplayName = (activity,t) => {
  
  if (activity.parentName && activity.id === activity.parentId)
  //  return activity.parentName.toUpperCase();
  return t(`other.${activity.idNum}`)
  if (activity.name && activity.id !== activity.parentId)
  //  return activity.name.toUpperCase();
  return t(`other.${activity.idNum}`)
};

export const getDisplayActicityName = (activity) => {
  
  if (activity.parentName && activity.id === activity.parentId)
   return activity.parentName.toUpperCase();
  if (activity.name && activity.id !== activity.parentId) return activity.name.toUpperCase();
};

export const getTargetCapacity = (activity, target) => {
  const capacity = parseFloat(activity.capacity);
  return fixDecimal(capacity * (target / 100.0), 2);
};

export const findActivitiesWithPrimary = (primary, responseArray) => {
  return responseArray.find((a) => a.building == primary);
};


